import { Row, Col } from 'reactstrap';
import useRouter from 'use-react-router';
import { useSelector } from 'react-redux';

import NavigationGroupTabs from 'common/components/buttons/NavigationGroupTabs';
import enumIcon from 'common/assets/svg/jobs/labels/enum.svg';
import companyIcon from 'common/assets/svg/common/company.svg';
import ListSelect from 'common/components/selectors/ListSelect';

import { selectListDefaultOptions } from 'store/lists/selectors';
import paths from 'routing/routes/_paths';

const TopFilters = () => {
  const organizationList = useSelector(state => selectListDefaultOptions(state, 'organizations'));
  const { match, history } = useRouter();
  const { path, params } = match;
  const { organizationId } = params;
  const isUnlinked = path?.includes('unlinked');

  const onChange = id => {
    history.replace({
      pathname: `${paths.enums.purchasing_stores_unlinked}/${id}`
    });
  };

  return (
    <Row className={`align-items-center w-100p`}>
      <Col xs={'auto'} className="d-flex align-items-center">
        <NavigationGroupTabs
          size="sm"
          tabs={[
            {
              label: 'Stores in Ocean',
              to: `${paths.enums.purchasing_stores}`,
              tooltip: 'Stores in Ocean',
              className: 'min-width-24 max-width-24',
              icon: enumIcon
            },
            {
              label: 'Unlinked',
              to: `${paths.enums.purchasing_stores_unlinked}/${
                organizationId || organizationList[0]?.id
              }`,
              tooltip: 'Unlinked Stores from Companies',
              className: 'min-width-24 max-width-24',
              icon: companyIcon
            }
          ]}
        />
      </Col>

      {isUnlinked ? (
        <Col xs={3} className="d-flex align-items-center">
          <ListSelect
            list="organizations"
            placeholder="Select companies"
            onChange={onChange}
            value={organizationId}
            className="mb-0 w-100p"
            size="sm"
          />
        </Col>
      ) : null}

      <Col xs="auto" className="d-flex align-items-center text-violet fs-10">
        {isUnlinked ? '*Unlinked Store from Companies' : '*Stores in Ocean'}
      </Col>
    </Row>
  );
};

export default TopFilters;
